// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__TSEE2","selects":"Documents_selects__xx9eV"};